{
    "greeting": "Hello, {name}!",
    "items": "{count, plural, one {# item} other {# items}}"
}
